import { render, staticRenderFns } from "./TepViajeDetalle.vue?vue&type=template&id=4780b8a2"
import script from "./TepViajeDetalle.vue?vue&type=script&lang=js"
export * from "./TepViajeDetalle.vue?vue&type=script&lang=js"
import style0 from "./TepViajeDetalle.vue?vue&type=style&index=0&id=4780b8a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports